import $ from 'jquery/dist/jquery.slim.min';

window.$ = $;
window.jQuery = $;
export default $;
